<template>
<div class="container">
    <div class="row">
        <div class="col-sm text-start pb-1">
            <span class="badge rounded-pill bg-success pull-left mt-1 py-2 px-4" style="font-size:16px; background:white">
                <b>กำหนดข้อมูลและค่าเงื่อนไขการทำงาน</b>
            </span>
        </div>
    </div>
    <div class="row text-start">
        <p class="fs-5 text-danger ms-3" style="">การเปลี่ยนแปลงข้อมูลในหน้านี้ จะมีผลก็ต่อเมื่อทำการเข้าระบบใหม่อีกครั้ง</p>
    </div>
    <div class="container">
        <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <button class="nav-link active" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-group" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">ข้อมูลคลินิก</button>
                <button class="nav-link" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-users" type="button" role="tab" aria-controls="nav-home" aria-selected="true">ตั้งค่าสถานะใบสั่งตรวจ</button>
                <button hidden class="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-groupauth" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">N/A</button>
            </div>
        </nav>
        <div class="tab-content" id="nav-tabContent">
            <div class="tab-pane fade show active" id="nav-group" role="tabpanel" aria-labelledby="nav-profile-tab">
                <Setting2Corp></Setting2Corp>
            </div>
            <div class="tab-pane fade" id="nav-users" role="tabpanel" aria-labelledby="nav-home-tab">
                <Setting2StatusStep :dataTestsLists="dataTestsLists"></Setting2StatusStep>
            </div>
            <div class="tab-pane fade" id="nav-groupauth" role="tabpanel" aria-labelledby="nav-contact-tab">
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
// import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

import Setting2Corp from './Setting2Corp.vue'
import Setting2StatusStep from './Setting2StatusStep.vue'

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  masks: {
    input: 'YYYY-MM-DD'
  },
  name: 'Setting',
  data () {
    return {
      // เทสในระบบทั้งหมด ส่งไปแสดงในหน้า Setting2StatusStep
      dataTestsLists: null

    }
  },
  created () {

  },
  mounted () {
    this.getTestsData()
  },
  components: {
    Setting2Corp, Setting2StatusStep
  },
  methods: {
    // ดึงรายการเทสทั้งหมด (ItemTest) สำหรับให้เลือกเพื่อเพิ่มในชุดตรวจ
    getTestsData () {
      MyApiClient.get('getdata/tests_all.php?C1=' + this.globalCorpID)
        .then((resp) => {
        //   console.log(resp.data.response)
          this.dataTestsLists = resp.data.response
          this.$nextTick(() => { $('#mySelectTestTable_eGFR').DataTable() })
          this.$nextTick(() => { $('#mySelectTestTable_Cr').DataTable() })
          // setTimeout(function () { $('#myTable').DataTable() }, 0)
        })
        .catch((err) => {
          console.log(err.response)
        })
    }
  }
}
</script>

<style>

</style>
